import WoosmapMultisearch from '../../data/woosmap/MultisearchTypes'

export interface MatchedSubstring {
  offset: number
  length: number
}
export interface IDropOffLocationSuggestionProps {
  id: string
  api: WoosmapMultisearch.API
  description: string
  types: string[]
  matchedSubstrings: MatchedSubstring[]
  highlight: string
  item: any
}

class AutocompleteSuggestion {
  public readonly id: string
  public readonly api: WoosmapMultisearch.API
  public readonly description: string
  public readonly types: Array<string>
  public readonly matchedSubstrings: Array<MatchedSubstring>
  public readonly highlight: string
  public readonly item: any

  constructor({ id, api, description, types, matchedSubstrings, highlight, item }: IDropOffLocationSuggestionProps) {
    this.id = id
    this.api = api
    this.description = description
    this.types = types
    this.matchedSubstrings = matchedSubstrings
    this.highlight = highlight
    this.item = item
  }

  public static from(from: WoosmapMultisearch.AutocompleteResponseItem): AutocompleteSuggestion {
    return {
      id: from.id,
      api: from.api,
      description: from.description,
      types: from.types,
      matchedSubstrings: from.matched_substrings,
      highlight: from.highlight,
      item: from.item
    }
  }
}

export default AutocompleteSuggestion
